import React from 'react';
import { Link } from 'react-router-dom';

const projects = [
    {
        year: '2025',
        project: 'The Last Sanctuary',
        type: 'Game',
        builtWith: ['Unity', 'C#'],
        remarks: 'A fast-paced 2D Top-down Action-Adventure Roguelike Game. Developed in Unity. Implemented player movement, enemy behaviour, and level design. Developed for the course Computer Game Software Production within 3 weeks. First-runner up in the course project showcase.',
        link: 'https://eflash.itch.io/the-last-sanctuary',
    },
    {
        year: '2025',
        project: 'WordyPals',
        type: 'Application/Game',
        builtWith: ['Unity', 'C#', 'Firebase'],
        remarks: 'An AI-powered English learning app for young learners (K2 to P1). Integrated advanced AI features: difficulty adjustment, personalized learning, intelligent error correction, speech/image recognition, and NLP. Supported deployment across 12+ schools with over 100 active users.',
        link: 'https://wordypalslcaplatfo.wixsite.com/my-site-1',
    },
    {
        year: '2025',
        project: 'MindVoyage',
        type: 'Application/Game',
        builtWith: ['Unity', 'C#', 'PostgreSQL', 'Linux', 'Ubuntu Server', 'Python', 'FastAPI'],
        remarks: 'An English learning platform for students and teachers under EdUHK’s Research Team. Managed a team of 3 developers and implemented core systems including authentication, student and teacher lobbies, and multi-role access architecture.',
        link: 'https://apps.apple.com/app/mindvoyage/id6753164049',
    },
    {
        year: '2025',
        project: 'Bubble Sea',
        type: 'Game',
        builtWith: ['Unity', 'C#'],
        remarks: 'A 2D underwater adventure game developed in Unity. Implemented player movement, enemy behaviour, and level design. Developed in the GGJHK 2025 within 40 hours in a team of 6.',
        link: 'https://globalgamejam.org/games/2025/project-bubble-4',
    },
    {
        year: '2024',
        project: 'Personal Portfolio Website',
        type: 'Web',
        builtWith: ['HTML', 'CSS', 'JavaScript', 'React'],
        remarks: 'A personal portfolio website to showcase projects and experiences.',
        link: './',
    },
    {
        year: '2024',
        project: 'Pixel Keyboard and Controller UI Customizer',
        type: 'Software',
        builtWith: ['Unity', 'C#', 'Aseprite'],
        remarks: 'A tool for customizing keyboard and controller pixel UI assets.',
        link: 'https://itch.io/c/4907903/pixel-keyboard-and-controller-ui-customizer',
    },
    {
        year: '2024',
        project: 'Realm of Ink',
        type: 'Game',
        builtWith: ['Unity', 'C#'],
        remarks: 'A 2D top-down action-adventure roguelike game developed in Unity. Involved in closed beta testing as an intern in Leap Studio.',
        link: 'https://store.steampowered.com/app/2597080/_/',
    },
    {
        year: '2024',
        project: 'Sorry, We Are Closed!',
        type: 'Game',
        builtWith: ['Unity', 'C#'],
        remarks: 'A 2D top-down shooter and business simulation game. Developed in Unity. Implemented player movement, enemy AI, and battle mechanics. Top 20% in the Brackeys Game Jam 2024.2.',
        link: 'https://scarletradio.itch.io/sorry',
    },
    {
        year: '2024',
        project: 'Bungee Gun',
        type: 'Game',
        builtWith: ['Unity', 'C#'],
        remarks: 'A 3D first-person shooter puzzle game developed in Unity. Implemented player movement, gun mechanics, and level design. Top 30% in the GMTK Game Jam 2024.',
        link: 'https://scarletradio.itch.io/bungeegun',
    },
    {
        year: '2024',
        project: 'Breakneck D',
        type: 'Game',
        builtWith: ['Unity', 'C#'],
        remarks: 'A 2D platformer game developed in Unity. Implemented player movement, level design, and game mechanics. Top 30% in the PolyMars x ScoreSpace Game Jam.',
        link: 'https://scarletradio.itch.io/breakneck-d',
    },
    {
        year: '2024',
        project: 'Real-time Multiplayer Game',
        type: 'Game',
        builtWith: ['Unity', 'C#', 'Netcode'],
        remarks: 'A 3D multiplayer game developed as a final year project. Won the Best Creativity Award in HKGD GCE 2024.',
        link: 'https://www.youtube.com/watch?v=fqLggAzfWwE', // Replace with actual link
    },
    {
        year: '2024',
        project: 'All-in-one Trip Planner',
        type: 'Software',
        builtWith: ['Android Studio', 'Kotlin', 'Jetpack Compose', 'Firebase Firestore', 'Volley'],
        remarks: 'An Android application for planning trips. Implemented the expense tracking and sharing system.',
        link: 'https://github.com/Circle-ma/CSCI3310Project'
    },
    {
        year: '2023',
        project: 'Location and Event Tracking System',
        type: 'Web',
        builtWith: ['HTML', 'CSS', 'JavaScript', 'React', 'NodeJS', 'MongoDB', 'Express'],
        remarks: 'A web application for tracking locations and events. Responsible for dataset preprocessing and implemented the locations and events display view.',
        link: 'https://github.com/billyxcc/C_Project',
    },
    {
        year: '2023',
        project: 'Peer-to-peer Music Sharing System',
        type: 'Software',
        builtWith: ['Python', 'Socket'],
        remarks: 'A system for sharing music files between users. Implemented the user interface and music management functionalities.',
        link: 'https://github.com/ChrisCheung33/CSCI3280Project',
    },
    {
        year: '2023',
        project: 'Fencing Trainer',
        type: 'Game',
        builtWith: ['Unity', 'C#', 'Meta Quest 2'],
        remarks: 'A VR game for fencing training. A project when I was an intern at AESIR HK.',
    },
    {
        year: '2023',
        project: 'Squat Trainer',
        type: 'Game',
        builtWith: ['Unity', 'C#', 'MediaPipe'],
        remarks: 'An AR game for squat training. A project when I was an intern at AESIR HK.',
    },
    {
        year: '2023',
        project: 'Social Media Platform',
        type: 'Web',
        builtWith: ['HTML', 'CSS', 'JavaScript', 'React', 'NodeJS', 'MongoDB', 'Express'],
        remarks: 'A social media platform for connecting users. Implemented the account-related frontend(user profile, register and login page, etc.) and backend(user authentication) design.',
        link: 'https://github.com/DonaldLamNL/buzzer',
    },
];

const Archive = () => {
    return (
        <section id="archive" className="py-5">
            <div className="container">
                {/* Add a back button to return to the main page */}
                <Link to="../" className="back-button">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="back-logo" aria-hidden="true">
                        <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clipRule="evenodd"></path>
                    </svg>
                    Back
                </Link>

                <h2>All Projects</h2>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Year</th>
                            <th>Project</th>
                            <th>Type</th>
                            <th>Built With</th>
                            <th>Remarks</th> {/* Changed from Link to Remarks */}
                        </tr>
                    </thead>
                    <tbody>
                        {projects.map((project, index) => (
                            <tr key={index}>
                                <td className="project-year">{project.year}</td>
                                <td className="project-name">
                                    <a className="nav-link" href={project.link} target="_blank" rel="noopener noreferrer">{project.project}</a> {/* Link on project name */}
                                </td>
                                <td className="project-type">{project.type}</td>
                                <td className="project-tech">
                                    <ul className="project-tag-list">
                                        {project.builtWith.map((tech, techIndex) => (
                                            <li key={techIndex}>
                                                <div className="project-tag">{tech}</div>
                                            </li>
                                        ))}
                                    </ul>
                                </td>
                                <td className="project-remarks"><div>{project.remarks}</div></td> {/* New Remarks column */}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    );
};

export default Archive;